export default __webpack_public_path__ + "static/pvsindhu-badminton-img-e1534f9dd20c503d213832e6478bde4f.png";